import React, { useState, useEffect } from 'react'
import {
    Grid,
    Typography,
    CircularProgress,
    Box,
    Breadcrumbs,
    Card,
    Divider,
} from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { makeStyles } from '@material-ui/styles'
import NFTsOverview from './components/NFTsOverview'

import {
    openSeaCollections,
    getOpenSeaCollectionsPrice,
    getOpenSeaCollectionsTable,
    getOpenSeaCollecionsAssetsNumber,
    coingeckoETH,
    getBalancePrice,
} from './utils'
import axios from 'axios'

const useStyles = makeStyles(theme => ({
    tableOverflow: {
        overflow: 'auto',
    },
}))
const formatter = new Intl.NumberFormat('en-US', {})

var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

const jpgContract = '0x19e5bb63c902c0690d1ba9b946ee8920e8dec3c6'
const Farming_Contract = '0x0B9d6b075e2e8816545d8b24e4651F4C8643f234'
const Farming_Contract2 = '0x83ff3924e69b1d04b9390ce28fd4c0bcd129fe05'

const uniswapContract = '0x6a6b3180ac33d67e5eb9169bf236109437d3c5d1'

const nftWallet = '0x0B9d6b075e2e8816545d8b24e4651F4C8643f234'
const nftWallet2 = '0x83ff3924e69b1d04b9390ce28fd4c0bcd129fe05'

async function balance(chainId, contract) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/balances_v2/${contract}/false/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}
function Dashboard() {
    const classes = useStyles()
    const [price, setPrice] = useState(0)
    const [priceLoader, setPriceLoader] = useState(0)
    const [hodlers, setHodlers] = useState(0)
    const [hodlersLoader, setHodlersLoader] = useState(0)

    const [liquidity, setLiquidity] = useState(0)
    const [liquidityLoader, setLiquidityLoader] = useState(0)

    const [nftPortfolioLoader, setNFTPortfolioLoader] = useState(0)
    const [nftPortfolio, setNFTPortfolio] = useState(0)

    const [nftPortfolioNumber, setNFTPortfolioNumber] = useState(0)
    const [nftDataTable, setNFTDataTable] = useState([])

    const [loader, setLoader] = useState(0)

    const [farming, setFarming] = useState(0)
    const [farmingLoader, setFarmingLoader] = useState(0)

    const [datatableData, setDatatableData] = useState([
        ['Ethereum', formatterUS.format(0)],
        ['Fantom', formatterUS.format(0)],
        ['Avalanche', formatterUS.format(0)],
    ])
    const [datatableData2, setDatatableData2] = useState([
        ['Polygon', formatterUS.format(0)],
        ['Binance Smart Chain', formatterUS.format(0)],
        ['MoonRiver', formatterUS.format(0)],
    ])

    useEffect(() => {
        const fetchPrice = async contract => {
            setPriceLoader(1)

            try {
                const response = await balance(1, contract)
                const jpgPrice =
                    response.data.data.data.items[0].contract_address ===
                    contract
                        ? response.data.data.data.items[0].quote_rate
                        : response.data.data.data.items[1].quote_rate

                setPrice(jpgPrice)
            } catch (error) {
                console.error(error.message)
            }
            setPriceLoader(0)
        }
        const walletValue = async (chainId, contract) => {
            try {
                const response = await balance(chainId, contract)
                var value = getBalancePrice(response)

                return value
            } catch (error) {
                console.error(error.message)
                return 0
            }
        }

        const fetchHodlers = async contract => {
            setHodlersLoader(1)

            try {
                // tokens/0x1454232149a0dc51e612b471fe6d3393e60d09ad/token_holders/
                //
                const response = await axios.get(
                    `https://effortless-leaf-336220.uc.r.appspot.com/token_holders/${contract}/1`
                )

                setHodlers(response.data.data.data.items.length)
            } catch (error) {
                console.error(error.message)
            }
            setHodlersLoader(0)
        }

        const fetchLiquidity = async contract => {
            setLiquidityLoader(1)
            try {
                const value = await walletValue(1, contract)
                setLiquidity(value)
            } catch (error) {
                console.error(error.message)
            }
            setLiquidityLoader(0)
        }

        const fetchNFTPortfolio = async () => {
            setNFTPortfolioLoader(1)
            try {
                const ethResponse = await coingeckoETH()

                const responseNFT = await openSeaCollections(nftWallet)
                const responseNFT2 = await openSeaCollections(nftWallet2)

                const priceP = await getOpenSeaCollectionsPrice(responseNFT)
                const priceP2 = await getOpenSeaCollectionsPrice(responseNFT2)

                const datatable = []
                await getOpenSeaCollectionsTable(responseNFT, datatable)
                await getOpenSeaCollectionsTable(responseNFT2, datatable)

                const number = getOpenSeaCollecionsAssetsNumber(responseNFT)
                const number2 = getOpenSeaCollecionsAssetsNumber(responseNFT2)

                setNFTPortfolio(
                    (priceP + priceP2) * ethResponse.data.ethereum.usd
                )
                setNFTPortfolioNumber(number + number2)
                setNFTDataTable(datatable)

                //   setNFTDataTable(responseNFT.data.collections);
            } catch (error) {
                // eslint-disable-next-line
                console.error(error.message)
            }
            setNFTPortfolioLoader(0)
        }

        const fetchFarming = async (contract, contract2) => {
            setFarmingLoader(1)
            try {
                const eth = await walletValue(1, contract)
                const fantom = await walletValue(250, contract)
                const avax = await walletValue(43114, contract)
                const moonRiver = await walletValue(1285, contract)

                const eth2 = await walletValue(1, contract2)
                const fantom2 = await walletValue(250, contract2)
                const avax2 = await walletValue(43114, contract2)
                const moonRiver2 = await walletValue(1285, contract2)

                setDatatableData([
                    ['Ethereum', formatterUS.format(eth + eth2)],
                    ['Fantom', formatterUS.format(fantom + fantom2)],
                    ['Avalanche', formatterUS.format(avax + avax2)],
                ])
                setDatatableData2([
                    ['Polygon', formatterUS.format(0)],
                    ['Binance Smart Chain', formatterUS.format(0)],
                    ['MoonRiver', formatterUS.format(moonRiver + moonRiver2)],
                ])
                setFarming(
                    eth +
                        fantom +
                        avax +
                        moonRiver +
                        eth2 +
                        fantom2 +
                        avax2 +
                        moonRiver2
                )
            } catch (error) {
                console.error(error.message)
            }
            setFarmingLoader(0)
        }

        const refresh = async () => {
            await Promise.all([
                fetchPrice(jpgContract),
                fetchHodlers(jpgContract),
                fetchLiquidity(uniswapContract),
                fetchNFTPortfolio(),
                fetchFarming(Farming_Contract, Farming_Contract2),
            ])
        }

        refresh()
    }, [])

    return (
        <Grid container spacing={4}>
            <Grid item lg={12} sm={12} xs={12}>
                <Card alignItems="center">
                    <Grid container spacing={1}>
                        <Grid item lg={12} sm={12} lg={12}>
                            <Typography
                                variant="h4"
                                style={{
                                    marginTop: 15,
                                    marginBottom: 15,
                                }}
                            >
                                &nbsp;&nbsp;&nbsp;&nbsp;Assets Under Management{' '}
                                {!farmingLoader ? (
                                    <Typography
                                        variant="span"
                                        style={{
                                            marginTop: 15,
                                            marginBottom: 15,
                                        }}
                                    >
                                        {formatterUS.format(farming)}
                                    </Typography>
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </Grid>
                        <Grid item lg={6} sm={12} xs={12}>
                            <MUIDataTable
                                data={datatableData}
                                columns={[
                                    {
                                        name: 'Network',
                                    },
                                    {
                                        name: 'Value (USD)',
                                    },
                                ]}
                                options={{
                                    filter: false,
                                    search: false,
                                    viewColumns: false,
                                    download: false,
                                    selectableRowsHeader: false,
                                    selectableRows: 'none',
                                    pagination: false,
                                    print: false,
                                    textLabels: {
                                        body: {
                                            noMatch: loader ? (
                                                <CircularProgress
                                                    size={26}
                                                    className={
                                                        classes.loginLoader
                                                    }
                                                />
                                            ) : (
                                                'Sorry, there is no data to display'
                                            ),
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item lg={6} sm={12} xs={12}>
                            <MUIDataTable
                                data={datatableData2}
                                columns={[
                                    {
                                        name: 'Network',
                                    },
                                    {
                                        name: 'Value (USD)',
                                    },
                                ]}
                                options={{
                                    filter: false,
                                    search: false,
                                    viewColumns: false,
                                    print: false,
                                    download: false,
                                    selectableRowsHeader: false,
                                    selectableRows: 'none',
                                    pagination: false,
                                    textLabels: {
                                        body: {
                                            noMatch: loader ? (
                                                <CircularProgress
                                                    size={26}
                                                    className={
                                                        classes.loginLoader
                                                    }
                                                />
                                            ) : (
                                                'Sorry, there is no data to display'
                                            ),
                                        },
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Card>
            </Grid>

            <Grid item lg={6} sm={12} xs={12}>
                <NFTsOverview
                    nftDataTable={nftDataTable}
                    assetsNumber={nftPortfolioNumber}
                    nftPortfolio={nftPortfolio}
                />
            </Grid>
            <Grid item lg={6} sm={12} xs={12}>
                {/*   <Card>
                    <Box pt={3} px={3}>
                        <Typography variant="h4" fontWeight="medium">
                            Supply Mechanics
                        </Typography>
                        <Box p={2}>
                            <Grid container spacing={3}>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card>
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Circulating
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatter.format(10000000)}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card>
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Burned
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatter.format(1000000)}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Card> */}
                <Card style={{ height: '300px', overflow: 'auto' }}>
                    <Box pt={3} px={3}>
                        <Typography variant="h4" fontWeight="medium">
                            Metrics
                        </Typography>
                        <Box p={2}>
                            <Grid container spacing={3}>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card
                                            style={{
                                                border: '1px solid',
                                                borderImageSlice: 1,
                                                borderImageSource:
                                                    'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                            }}
                                        >
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Market Cap
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatterUS.format(
                                                        price * 10000000
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card
                                            style={{
                                                border: '1px solid',
                                                borderImageSlice: 1,
                                                borderImageSource:
                                                    'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                            }}
                                        >
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Price
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatterUS.format(price)}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card
                                            style={{
                                                border: '1px solid',
                                                borderImageSlice: 1,
                                                borderImageSource:
                                                    'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                            }}
                                        >
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Hodlers
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatter.format(hodlers)}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                    <Box mb={1.5}>
                                        <Card
                                            style={{
                                                border: '1px solid',
                                                borderImageSlice: 1,
                                                borderImageSource:
                                                    'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                            }}
                                        >
                                            <Box
                                                pb={2}
                                                px={2}
                                                textAlign="center"
                                                lineHeight={1.25}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    textTransform="capitalize"
                                                >
                                                    Liquidity
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text"
                                                    fontWeight="regular"
                                                >
                                                    {formatterUS.format(
                                                        liquidity
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Card>
            </Grid>

            {/*  <Grid item lg={3} sm={6} xs={12}>
                <Widget
                    title="Market Cap"
                    bodyClass={classes.fullHeightBody}
                    className={classes.card}
                    disableWidgetMenu
                >
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={6}>
                            <Box display="flex">
                                {!priceLoader ? (
                                    <Typography variant="h2" weight="medium">
                                        {formatter.format(price * 500000000000)}
                                    </Typography>
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <div>
                            <p></p>
                        </div>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        wrap={'nowrap'}
                    >
                        <Grid item>
                            <Typography
                                color="text"
                                colorBrightness={'hint'}
                                variant={'caption'}
                                style={{ marginRight: 5 }}
                                noWrap
                            >
                                Hodlers
                            </Typography>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent={'center'}
                            >
                                {!hodlersLoader ? (
                                    <Typography
                                        size="md"
                                        weight={'medium'}
                                        style={{ marginRight: 8 }}
                                    >
                                        {hodlers}
                                    </Typography>
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                                <Dot color="primary" />
                            </Box>
                        </Grid>
                        <Grid item>
                            <Typography
                                color="text"
                                colorBrightness={'hint'}
                                variant={'caption'}
                                style={{ marginRight: 5 }}
                            >
                                Total Liquidity
                            </Typography>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent={'center'}
                            >
                                {!liquidityLoader ? (
                                    <Typography
                                        size="md"
                                        weight={'medium'}
                                        style={{ marginRight: 8 }}
                                    >
                                        {formatter.format(liquidity)}
                                    </Typography>
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}

                                <Dot color="secondary" />
                            </Box>
                        </Grid>
                    </Grid>
                </Widget>
            </Grid> */}
        </Grid>
    )
}

// #######################################################################

function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
    var array = new Array(length).fill()
    let lastValue

    return array.map((item, index) => {
        let randomValue = Math.floor(Math.random() * multiplier + 1)

        while (
            randomValue <= min ||
            randomValue >= max ||
            (lastValue && randomValue - lastValue > maxDiff)
        ) {
            randomValue = Math.floor(Math.random() * multiplier + 1)
        }

        lastValue = randomValue

        return { value: randomValue }
    })
}

export default Dashboard
